"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.applyOpacity = applyOpacity;
exports.calculateTextColorForBackground = void 0;
exports.darken = darken;
exports.hexToRgbString = hexToRgbString;
exports.isOpaque = isOpaque;
exports.isTransparent = isTransparent;
exports.isValidColor = isValidColor;
exports.lighten = lighten;
exports.makeOpaque = makeOpaque;
exports.nextColorInScale = nextColorInScale;
exports.opacityHex = opacityHex;
var _color = _interopRequireDefault(require("color"));
var _colors = _interopRequireDefault(require("../styles/colors"));
var _shared = require("./shared.utils");
var _error = require("../components/common/error.utils");
function nextColorInScale(color) {
  if (!color) {
    return null;
  }
  var matchFirstNumber = color.match(/[0-9]/);
  if (!matchFirstNumber) {
    return null;
  }
  var indexOfFirstNumber = matchFirstNumber.index;
  if (!indexOfFirstNumber) {
    return null;
  }
  var scale = color.substring(0, indexOfFirstNumber);
  var number = Number(color.substring(indexOfFirstNumber));
  if (!scale || !number) {
    return null;
  }
  var nextInScaleKey1 = "".concat(scale).concat(number + 10);
  if (_colors["default"][nextInScaleKey1]) {
    return nextInScaleKey1;
  }
  var nextInScaleKey2 = "".concat(scale).concat(number + 100);
  if (_colors["default"][nextInScaleKey2]) {
    return nextInScaleKey2;
  }
  return null;
}
function lighten(color, value) {
  return (0, _color["default"])(color).lighten(value).hex();
}
function darken(color, value) {
  if (!color.startsWith('rgba')) {
    return (0, _color["default"])(color).darken(value).hex();
  }
  // if it's rgba with transparency - add the value to the alpha
  var newAlpha = (0, _color["default"])(color).rgb().round().array()[3] + value;
  if (newAlpha > 1) {
    // if the summed transparency is bigger than one - fallback to regular darkening
    return (0, _color["default"])(color).darken(value).hex();
  }
  return (0, _color["default"])(color).alpha(newAlpha).toString();
}
function isTransparent(color) {
  return color === 'rgba(0, 0, 0, 0)' || color === 'transparent';
}
function isOpaque(color) {
  return isValidColor(color) && (0, _color["default"])(color).alpha() === 1;
}
function isValidColor(color) {
  if (!color) {
    return false;
  }
  try {
    (0, _color["default"])(color);
    return true;
  } catch (_unused) {
    return false;
  }
}

// TBD this function name is still kept for backward compatibility purpose
function opacityHex(hex, opacity) {
  if (hex) {
    var tempHex = hex.replace('#', '');
    var r = parseInt(tempHex.substring(0, 2), 16);
    var g = parseInt(tempHex.substring(2, 4), 16);
    var b = parseInt(tempHex.substring(4, 6), 16);
    return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(opacity / 100, ")");
  }
  return null;
}

/** Return a color with a relative percentage opacity.
@param color rgb, rgba, hex, hex with alpha, hsl, hsla or named colors.
@param opacity is the relative percentage of opacity. if color already has opacity, the result will be the product of both opacities. */
function applyOpacity(color, opacity) {
  if (!isValidColor(color)) {
    return null;
  }
  var colorObj = (0, _color["default"])(color);
  var opacityAsDecimal = opacity / 100;
  var alphaProduct = colorObj.alpha() * opacityAsDecimal;
  var rounded = (0, _shared.roundToDecimal)(alphaProduct, 2);
  return colorObj.alpha(rounded).rgb().string();
}
function makeOpaque(color) {
  if (!isValidColor(color)) {
    // couldn't think of a better fallback, as i don't want to enforce a specific default color,
    // and most probably the color will be interpreted somehow by css.
    // eslint-disable-next-line no-console
    (0, _error.trackError)(new Error("@color.utils: provided color is not valid"), {
      color: color
    });
    return color;
  }
  return (0, _color["default"])(color).alpha(1).rgb().string();
}
function hexToRgbString(color) {
  if (!isValidColor(color)) {
    // eslint-disable-next-line no-console
    (0, _error.trackError)(new Error("@color.utils: provided color is not valid"), {
      color: color
    });
    return color;
  }
  return (0, _color["default"])(color).rgb().array().join(', ');
}

/** Calculates the text color that should be used on a given background color.
 * If the background color is not valid, black will be returned by default.
 * @param backgroundColor
 */
var calculateTextColorForBackground = exports.calculateTextColorForBackground = function calculateTextColorForBackground(backgroundColor) {
  if (!backgroundColor || !isValidColor(backgroundColor)) {
    return _colors["default"].textPrimary;
  }
  return (0, _color["default"])(backgroundColor).isLight() ? _colors["default"].textPrimary : _colors["default"].white;
};
//# sourceMappingURL=color.utils.js.map